"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AreaOfLawEnum = exports.CommunicationRequestorType = exports.StatusEnum = exports.ActionEnum = void 0;
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["PROVIDER_CREATE"] = "PROVIDER_CREATE";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["UPDATE_ASSIGNEE"] = "UPDATE_ASSIGNEE";
    ActionEnum["UPDATE_CONFLICTS"] = "UPDATE_CONFLICTS";
    ActionEnum["UPDATE_AREA_OF_LAW"] = "UPDATE_AREA_OF_LAW";
    ActionEnum["UPDATE_QUICK_ALERT"] = "UPDATE_QUICK_ALERT";
    ActionEnum["UPDATE_CRITICAL_DATE"] = "UPDATE_CRITICAL_DATE";
    ActionEnum["ADD_NOTE"] = "ADD_NOTE";
    ActionEnum["UPDATE_NOTES"] = "UPDATE_NOTES";
    ActionEnum["ADD_ATTACHMENT"] = "ADD_ATTACHMENT";
    ActionEnum["MIGRATE_CREATE"] = "MIGRATE_CREATE";
    ActionEnum["MIGRATE_UPDATE"] = "MIGRATE_UPDATE";
    ActionEnum["UPDATE_WILL_COMPLETED"] = "UPDATE_WILL_COMPLETED";
    ActionEnum["REFER"] = "REFER";
    ActionEnum["RECLAIM"] = "RECLAIM";
    ActionEnum["CLOSE"] = "CLOSE";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["POPULATE_DUE_BY"] = "POPULATE_DUE_BY";
    ActionEnum["POPULATE_COMPLIANCE"] = "POPULATE_COMPLIANCE";
    ActionEnum["CLEAR_ASSIGNEE"] = "CLEAR_ASSIGNEE";
    ActionEnum["MIGRATE_CHANGE_OWNER"] = "MIGRATE_CHANGE_OWNER";
    ActionEnum["CLEAR_QUICK_ALERT"] = "CLEAR_QUICK_ALERT";
    ActionEnum["CLEAR_CRITICAL_DATE"] = "CLEAR_CRITICAL_DATE";
    ActionEnum["CHANGE_ENTITLEMENT"] = "CHANGE_ENTITLEMENT";
    ActionEnum["ADD_ALERT"] = "ADD_ALERT";
    ActionEnum["UPDATE_ALERT_STATUS"] = "UPDATE_ALERT_STATUS";
    ActionEnum["UPDATE_LOCALE"] = "UPDATE_LOCALE";
    ActionEnum["REPROCESS_ANSWERS"] = "REPROCESS_ANSWERS";
    ActionEnum["MIGRATE_BRANCH_ACCESS"] = "MIGRATE_BRANCH_ACCESS";
    ActionEnum["ADD_TALKDESK_INTERACTION"] = "ADD_TALKDESK_INTERACTION";
    ActionEnum["ADD_CHAT"] = "ADD_CHAT";
    ActionEnum["REMOVE_CHAT"] = "REMOVE_CHAT";
    ActionEnum["ACKNOWLEDGE_CHAT"] = "ACKNOWLEDGE_CHAT";
    ActionEnum["ADD_SCHEDULED_CALL"] = "ADD_SCHEDULED_CALL";
    ActionEnum["UPDATE_SURVEY_ANSWER"] = "UPDATE_SURVEY_ANSWER";
    ActionEnum["DISMISS_REOPEN_SURVEY"] = "DISMISS_REOPEN_SURVEY";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["NEW"] = "NEW";
    StatusEnum["CALL_ATTEMPT_MADE"] = "CALL_ATTEMPT_MADE";
    StatusEnum["COMMUNICATION_SENT"] = "COMMUNICATION_SENT";
    StatusEnum["CLOSED"] = "CLOSED";
    StatusEnum["WAITING_ON_MEMBER"] = "WAITING_ON_MEMBER";
    StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    StatusEnum["TO_BE_REFERRED"] = "TO_BE_REFERRED";
    StatusEnum["REFERRED"] = "REFERRED";
    StatusEnum["RE_OPENED"] = "RE_OPENED";
    StatusEnum["RECLAIMED"] = "RECLAIMED";
    StatusEnum["DISCARD"] = "DISCARD";
    StatusEnum["READY_TO_PICK_UP"] = "READY_TO_PICK_UP";
    StatusEnum["WILL_PENDING"] = "WILL_PENDING";
    StatusEnum["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    StatusEnum["CALL_STARTED"] = "CALL_STARTED";
    StatusEnum["NEW_DOCUMENTS"] = "NEW_DOCUMENTS";
    StatusEnum["NEW_UPDATES"] = "NEW_UPDATES";
    StatusEnum["REOPEN_REQUESTED"] = "REOPEN_REQUESTED";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var CommunicationRequestorType;
(function (CommunicationRequestorType) {
    CommunicationRequestorType["INTERNAL"] = "INTERNAL";
    CommunicationRequestorType["PROVIDER"] = "PROVIDER";
    CommunicationRequestorType["MEMBER"] = "MEMBER";
})(CommunicationRequestorType = exports.CommunicationRequestorType || (exports.CommunicationRequestorType = {}));
var AreaOfLawEnum;
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(AreaOfLawEnum = exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://servicerequests.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title ServiceRequests Service Api
 * @version v1
 * @baseUrl https://servicerequests.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess
             * @request POST:/v2/migration/users/{identityId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/migration/users/${identityId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess2
             * @request POST:/v2/migration/identities/{identityId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/migration/identities/${identityId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsCreateServiceRequest
             * @request POST:/v2/identities/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsCreateServiceRequest: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestsByUserIdAll
             * @request GET:/v2/identities/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsGetServiceRequestsByUserIdAll: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestById
             * @request GET:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}
             * @secure
             */
            serviceRequestsGetServiceRequestById: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAssignee
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAssignee
             * @secure
             */
            serviceRequestsUpdateAssignee: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAssignee`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAreaOfLaw
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAreaOfLaw
             * @secure
             */
            serviceRequestsUpdateAreaOfLaw: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAreaOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateConflictsCleared
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateConflictsChecked
             * @secure
             */
            serviceRequestsUpdateConflictsCleared: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateConflictsChecked`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateStatus
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateStatus
             * @secure
             */
            serviceRequestsUpdateStatus: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateQuickAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateQuickAlert
             * @secure
             */
            serviceRequestsUpdateQuickAlert: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateQuickAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateCriticalDate
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateCriticalDate
             * @secure
             */
            serviceRequestsUpdateCriticalDate: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateCriticalDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddNote
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addNote
             * @secure
             */
            serviceRequestsAddNote: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateWillCompleted
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateWillCompleted
             * @secure
             */
            serviceRequestsUpdateWillCompleted: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateWillCompleted`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReclaim
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/reclaim
             * @secure
             */
            serviceRequestsReclaim: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/reclaim`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRefer
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/refer
             * @secure
             */
            serviceRequestsRefer: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/refer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClose
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/close
             * @secure
             */
            serviceRequestsClose: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/close`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearAssignee
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearAssignee
             * @secure
             */
            serviceRequestsClearAssignee: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearAssignee`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearQuickAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearQuickAlert
             * @secure
             */
            serviceRequestsClearQuickAlert: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearQuickAlert`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearCriticalDate
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearCriticalDate
             * @secure
             */
            serviceRequestsClearCriticalDate: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearCriticalDate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeOwner
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/changeOwner
             * @secure
             */
            serviceRequestsChangeOwner: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeEntitlement
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/changeEntitlement
             * @secure
             */
            serviceRequestsChangeEntitlement: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addAlert
             * @secure
             */
            serviceRequestsAddAlert: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAlertStatus
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAlertStatus/{communicationId}
             * @deprecated
             * @secure
             */
            serviceRequestsUpdateAlertStatus: (identityId, serviceRequestId, communicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAlertStatus/${communicationId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateLocale
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateLocale
             * @secure
             */
            serviceRequestsUpdateLocale: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReprocessAnswers
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/reprocessAnswers
             * @secure
             */
            serviceRequestsReprocessAnswers: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/reprocessAnswers`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddTalkdeskInteraction
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addTalkdeskInteraction
             * @secure
             */
            serviceRequestsAddTalkdeskInteraction: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addTalkdeskInteraction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddChat
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addChat
             * @secure
             */
            serviceRequestsAddChat: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addChat`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRemoveChat
             * @request DELETE:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/chats/{chatId}
             * @secure
             */
            serviceRequestsRemoveChat: (identityId, serviceRequestId, chatId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/chats/${chatId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateChatLastAcknowledgedVersion
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/chats/{chatId}/acknowledge
             * @secure
             */
            serviceRequestsUpdateChatLastAcknowledgedVersion: (identityId, serviceRequestId, chatId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/chats/${chatId}/acknowledge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsStartChat
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/startChat
             * @secure
             */
            serviceRequestsStartChat: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/startChat`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddScheduledCall
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addScheduledCall
             * @secure
             */
            serviceRequestsAddScheduledCall: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addScheduledCall`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateSurveyAnswerId
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateReopenRequestAnswerId
             * @secure
             */
            serviceRequestsUpdateSurveyAnswerId: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateReopenRequestAnswerId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsDismissMemberSurvey
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/dismissReopenSurvey
             * @secure
             */
            serviceRequestsDismissMemberSurvey: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/dismissReopenSurvey`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalGetJournalChangesAll
             * @request GET:/v2/servicerequests/journal
             * @secure
             */
            serviceRequestsJournalGetJournalChangesAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/servicerequests/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TalkDesk
             * @name TalkDeskGetTokenForCall
             * @request POST:/v2/talkDesk/tokenForCall
             * @secure
             */
            talkDeskGetTokenForCall: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/talkDesk/tokenForCall`, method: 'POST', secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess3
             * @request POST:/v1/migration/users/{userId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess3: (identityId, serviceRequestId, userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/migration/users/${userId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationBackfillCompliance
             * @request POST:/v1/complianceBackfill/{identityId}/serviceRequests/{serviceRequestId}
             * @secure
             */
            migrationBackfillCompliance: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/complianceBackfill/${identityId}/serviceRequests/${serviceRequestId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsCreateServiceRequest2
             * @request POST:/v1/users/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsCreateServiceRequest2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestsByUserId
             * @request GET:/v1/users/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsGetServiceRequestsByUserId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestById2
             * @request GET:/v1/users/{identityId}/serviceRequests/{serviceRequestId}
             * @secure
             */
            serviceRequestsGetServiceRequestById2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAssignee2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAssignee
             * @secure
             */
            serviceRequestsUpdateAssignee2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAssignee`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAreaOfLaw2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAreaOfLaw
             * @secure
             */
            serviceRequestsUpdateAreaOfLaw2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAreaOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateConflictsCleared2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateConflictsChecked
             * @secure
             */
            serviceRequestsUpdateConflictsCleared2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateConflictsChecked`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateStatus2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateStatus
             * @secure
             */
            serviceRequestsUpdateStatus2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateQuickAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateQuickAlert
             * @secure
             */
            serviceRequestsUpdateQuickAlert2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateQuickAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateCriticalDate2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateCriticalDate
             * @secure
             */
            serviceRequestsUpdateCriticalDate2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateCriticalDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddNote2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addNote
             * @secure
             */
            serviceRequestsAddNote2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateWillCompleted2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateWillCompleted
             * @secure
             */
            serviceRequestsUpdateWillCompleted2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateWillCompleted`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReclaim2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/reclaim
             * @secure
             */
            serviceRequestsReclaim2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/reclaim`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRefer2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/refer
             * @secure
             */
            serviceRequestsRefer2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/refer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClose2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/close
             * @secure
             */
            serviceRequestsClose2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/close`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearAssignee2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearAssignee
             * @secure
             */
            serviceRequestsClearAssignee2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearAssignee`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearQuickAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearQuickAlert
             * @secure
             */
            serviceRequestsClearQuickAlert2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearQuickAlert`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearCriticalDate2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearCriticalDate
             * @secure
             */
            serviceRequestsClearCriticalDate2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearCriticalDate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeOwner2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/changeOwner
             * @secure
             */
            serviceRequestsChangeOwner2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeEntitlement2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/changeEntitlement
             * @secure
             */
            serviceRequestsChangeEntitlement2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addAlert
             * @secure
             */
            serviceRequestsAddAlert2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAlertStatus2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAlertStatus/{communicationId}
             * @deprecated
             * @secure
             */
            serviceRequestsUpdateAlertStatus2: (identityId, serviceRequestId, communicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAlertStatus/${communicationId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateLocale2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateLocale
             * @secure
             */
            serviceRequestsUpdateLocale2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReprocessAnswers2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/reprocessAnswers
             * @secure
             */
            serviceRequestsReprocessAnswers2: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/reprocessAnswers`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddTalkdeskInteraction2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addTalkdeskInteraction
             * @secure
             */
            serviceRequestsAddTalkdeskInteraction2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addTalkdeskInteraction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalGetJournalChanges
             * @request GET:/v1/servicerequests/journal
             * @secure
             */
            serviceRequestsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/servicerequests/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
        this.maxClock = {
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalMaxClock
             * @request GET:/maxClock
             * @secure
             */
            serviceRequestsJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=servicerequests.js.map